import './pages.css';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { actionTypes } from './../../store';
import InputMask from 'react-input-mask';
import axios from "axios";
import { validationCpf, validationEmail } from "../../validations.js";
import { differenceInYears, parseISO } from 'date-fns';
import parse from 'html-react-parser';


export default function Exoma({ changePage }) {
    const data = useSelector((state) => state.data?.exoma);
    const dispatch = useDispatch();
    const states = useSelector((state) => state.states);
    const [showFullText, setShowFullText] = useState(false);
    const baseData = {
        "nome_completo": "",
        "data_de_nascimento": "",
        // (restante dos campos)
    };

    const [currentData, setCurrentData] = useState({ ...baseData, ...data });
    const itemsOptions = ["Prematuridade", "Restrição de crescimento intrauterino", "Atraso no desenvolvimento da linguagem",
        "Regressão neurológica", "Autismo/Espectro autista", "Deficiência intelectual", "Perda de audição",
        "Hipotonia", "Hipertonia/Espasticidade", "Convulsões", "Ataxia", "Movimentos anormais", "Dismorfismos",
        "Baixa estatura", "Alta estatura", "Microcefalia", "Macrocefalia", "Hiperextensibilidade",
        "Contraturas nas articulações", "Obesidade/Crescimento anormal", "Ganho ponderal insuficiente",
        "Alterações estruturais de SNC", "Malformações oculares", "Perda de visão", "Problemas cardiácos congênitos",
        "Alterações renais", "Alterações esqueléticas", "Escoliose", "Malformação dos membros", "Alterações na pele",
        "Alterações da genitália", "Organomegalia", "Hemi-hipertrofia", "Câncer/tumores",
        "Familiares com os mesmos sintomas (quais?)", "Outros achados relevantes"];

    const [patientItems, setPatientItems] = useState([
        { id: 'nome_completo', text: 'Nome completo', type: 'input', class: 'col-xs-12 col-lg-8' },
        { id: 'data_de_nascimento', text: 'Data de Nascimento', type: 'input', props: { type: 'date' }, class: 'col-xs-12 col-lg-4' }
    ]);

    const [items, setItems] = useState([{
        id: 'select', text: 'select', type: "radio", class: "col-xs-12  col-lg-7",
        options: [
            { id: 'sim', name: '', input: true, class: "col-xs-12  col-lg-8" },
            { id: 'nao', name: '', class: "col-xs-12  col-lg-2 justify-content-center" },
            { id: 'nao_sei', name: '', class: "col-xs-12  col-lg-2 justify-content-center" }
        ]
    }]);

    const itemsTitle = [
        { id: 'Descreva', name: '', type: 'input', class: 'col-xs-12 col-lg-8' },
        { id: 'Nao', name: '', type: 'checkbox', class: "col-xs-12  col-lg-2 text-center p-0" },
        { id: 'Nao_sei', type: 'checkbox', class: "col-xs-12  col-lg-2 text-center p-0" },
    ];

    const handleSubmit = (event) => {
        event.preventDefault();
        var eventName = event.nativeEvent.submitter.name;
        var hasError = false;

        // Verificação dos campos obrigatórios
        var fields = ['nome_completo', 'data_de_nascimento', ...itemsOptions];
        fields.forEach((f) => {
            if (!(f in currentData) || currentData[f] == "" || currentData[f] == null) {
                setError(f, 'Campo Obrigatório');
                hasError = true;
            } else {
                setError(f, null);
            }
        });

        // Verifica se o usuário selecionou "Sim" e se o campo de descrição está vazio
        itemsOptions.forEach((f) => {
            if (currentData[f] === "sim" && (!currentData[`${f}_desc`] || currentData[`${f}_desc`].trim() === "")) {
                setError(`${f}_desc`, "Campo Obrigatório");
                hasError = true;
            }
        });

        if (!hasError) {
            changePage(eventName);
        }
    };

    const setValue = (id, value) => {
        setError(id, null);
        setCurrentData((actualData) => ({ ...actualData, [id]: value }));
    };

    function setError(id, value, key = "error") {
        setPatientItems((currentItens) => currentItens.map((i) => {
            if (i.id === id) {
                return { ...i, [key]: value };
            }
            return i;
        }));
    }

    useEffect(() => {
        if (currentData) {
            dispatch({ type: actionTypes.set_data, 'payload': { "exoma": currentData } });
        }
    }, [currentData]);

    const getItem = (i, d) => {
        switch (i.type) {
            case "b":
                return (
                    <b id={i.id} className="subtitle">{i.title} {i.error && <span className='text-error'>({i.error})</span>}</b>
                );
            case "input":
                var value = (d && i.id in d) ? d[i.id] : null;
                return (
                    <InputMask key={i.id} id={i.id} name={i.id} type="text" placeholder={i.placeholder} title=""
                        value={value} autoComplete="off" {...i.props} disabled={i.disabled === true}
                        onChange={(event) => setValue(i.id, event.target.value)} mask={i.mask}
                        className={i.error ? 'border-danger' : ''} />
                );
            case "checkbox":
                var value = (d && i.id in d) ? d[`${i.tag}age_${i.id}`] : null;
                return (
                    <label key={i.id} className="label-input label-radio d-flex">
                        <input id={i.id} className="checkInput" type="checkbox" name={i.id}
                            checked={d && d[i.id]} onChange={(event) => setValue(i.id, event.target.checked)} />
                        {i.name && <b>{parse(i.name)}</b>}
                        {(i.input === true && d[i.id] === true) &&
                            <InputMask key={`input_${i.id}`} id={`input_${i.id}`} name={`input_${i.id}`}
                                type="text" value={value} autoComplete="off"
                                placeholder={i.placeholder}
                                onChange={(event) => setValue(`age_${i.id}`, event.target.value)}
                                className={i.error ? 'border-danger' : ''} />
                        }
                    </label>
                );
            case "select":
                return (
                    <select key={i.id} id={i.id} name={i.id} onChange={(event) => setValue(i.id, event.target.value)}>
                        {i.options?.map((o) => (
                            <option key={o.id} value={o.id}>
                                {parse(o.name)}
                            </option>
                        ))}
                    </select>
                );
            case "radio":
                return (
                    <div key={i.id} id={i.id} className="d-flex div-radio g-0">
                        {i.options?.map((o) => (
                            <label key={o.id} className={`label-input label-radio d-flex ${o.class}`}>
                                <input id={o.id} className="radioInput" type="radio" name={i.id}
                                    checked={(d && i.id in d) ? d[i.id] === o.id : null}
                                    onChange={(event) => setValue(i.id, event.target.id)} />
                                {o.name && <b>{parse(o.name)}</b>}
                                {(o.input === true && d[i.id] === o.id) &&
                                    <InputMask key={`input_${i.id}_desc`} id={`input_${i.id}_desc`} name={`input_${i.id}_desc`}
                                        type="text" value={(d && `${i.id}_desc` in d) ? d[`${i.id}_desc`] : null} autoComplete="off"
                                        placeholder={o.placeholder}
                                        onChange={(event) => setValue(`${i.id}_desc`, event.target.value)}
                                        className={i.error ? 'border-danger' : ''} />
                                }
                            </label>
                        ))}
                    </div>
                );
            case "hr":
                return (<hr key={i.id} />);
            default:
                return (<div key={i.id} className={`div-input ${i.class}`}></div>);
        }
    };

        return (
            <div className="basePage">
                <h4 className="title">Ficha de Dados Clínicos</h4>
                <p className="subtitle">para Teste Genético de Sequenciamento de Exoma</p>
                <form key="form2" id="form2" onSubmit={handleSubmit}>
                    <div className="row g-0">
                        {patientItems.map((i) => {
                            if (!("show" in i) || i.show.every((s) => currentData[s.key] === s.value)) {
                                return (
                                    <div key={i.id} className={`div-input ${i.class}`}>
                                        {i.text !== '' && <label htmlFor={i.id} className="label-input">{i.text}</label>}
                                        <div className="input-page-1" style={{ width: "100%" }}>
                                            {getItem(i, currentData)}
                                            {i.error && <span className="error-text">{i.error}</span>}
                                        </div>
                                    </div>
                                );
                            }
                            return null;
                        })}
                        <div className={`div-input col-xs-12 col-lg-12 table-history`}>
                            <br />
                            <div className="row g-0">
                                <b className={`header-items col-xs-12 col-lg-5`}></b>
                                <div className="row g-0 col-xs-12 col-lg-7">
                                    {itemsTitle.map((i) => (
                                        <b key={i.id} className={`header-items ${i.class}`}>{i.text}</b>
                                    ))}
                                </div>
                                <hr />
                            </div>
                            {itemsOptions.map((c) => (
                                <div key={c} className="row g-0">
                                    <div className={`div-input col-xs-12 col-lg-5`}>
                                        {getItem({
                                            id: `${c}name`,
                                            title: c,
                                            type: "b",
                                            error: (!(c in currentData) || currentData[c] === null) ? 'Campo Obrigatório' : ''
                                        }, currentData)}
                                    </div>
                                    <div className="div-input col-xs-12 col-lg-7">
                                        <label className="label-radio">
                                            <input
                                                id={`${c}_sim`}
                                                type="radio"
                                                className="radioInput"
                                                name={c}
                                                checked={currentData[c] === "sim"}
                                                onChange={() => setValue(c, "sim")}
                                            />
                                            {currentData[c] === "sim" ? (
                                                <InputMask
                                                    id={`input_${c}_desc`}
                                                    name={`input_${c}_desc`}
                                                    type="text"
                                                    value={currentData[`${c}_desc`] || ""}
                                                    autoComplete="off"
                                                    placeholder="Descreva"
                                                    onChange={(event) => setValue(`${c}_desc`, event.target.value)}
                                                    className={currentData[`${c}_desc`] ? '' : 'border-danger'}
                                                />
                                            ) : (
                                                <b>Sim (Descreva)</b>
                                            )}
                                        </label>
                                        <label className="label-radio">
                                            <input
                                                id={`${c}_nao`}
                                                type="radio"
                                                className="radioInput"
                                                name={c}
                                                checked={currentData[c] === "nao"}
                                                onChange={() => setValue(c, "nao")}
                                            />
                                            <b>Não</b>
                                        </label>
                                        <label className="label-radio">
                                            <input
                                                id={`${c}_nao_sei`}
                                                type="radio"
                                                className="radioInput"
                                                name={c}
                                                checked={currentData[c] === "nao_sei"}
                                                onChange={() => setValue(c, "nao_sei")}
                                            />
                                            <b>Não sei</b>
                                        </label>
                                    </div>
                                    <hr />
                                </div>
                            ))}
                        </div>
                    </div>
                </form>
                <br />
            </div>
        );

}
